module.exports = __webpack_public_path__ + "img/advantage.1035a1ff.png";